import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../services/config';
import { AddressEndpoint } from '../constants/address-endpoint';
import { AddressDetailsModel, AddressRequestModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AddressItemService {
  constructor(private http: WrapperHttpService) {}

  getAddressDetails(addressId: string): Observable<AddressDetailsModel> {
    return this.http.withLoading().get<AddressDetailsModel>(`${API_URL}${AddressEndpoint.Base}/${addressId}`);
  }

  createAddress(body: AddressRequestModel): Observable<AddressDetailsModel> {
    return this.http.withLoading().post<AddressDetailsModel>(`${API_URL}${AddressEndpoint.Base}`, body);
  }

  updateAddress(body: AddressRequestModel): Observable<AddressDetailsModel> {
    return this.http.withLoading().post<AddressDetailsModel>(`${API_URL}${AddressEndpoint.Base}`, body);
  }

  deleteAddress(addressId: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${AddressEndpoint.Base}?id=${addressId}`);
  }
}
